import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  template: '<p-progressSpinner></p-progressSpinner>',
  imports: [ProgressSpinnerModule],
})
export class LoadingComponent {}
